import get from 'lodash/get';
import forEach from 'lodash/forEach';
import isNaN from 'lodash/isNaN';
import isEmpty from 'lodash/isEmpty';
import {
  TYPE_TEXT_FIELD,
  TYPE_SELECT_FIELD,
  TYPE_TAXONOMY_FIELD,
  TEXTTYPE_NUMBER,
  TYPE_DATE_FIELD,
  TYPE_NUMBER_FIELD,
} from '../../constants';
/*
  This function is used to update the format of input values coming from UI
  and filter out invalid values, in order to comply with Metadata's accepted values and formats
*/
/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
const updateFormResponse = (components: any = {}, response: any = {}) => {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  const newResponse: Record<string, any> = {};
  const responseMap = {
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7006
    [TYPE_SELECT_FIELD]: (value, key, component) => {
      // If Single Select
      if (
        (component.multiSelect ||
          component.maximumSelections === 0 ||
          component.maximumSelections > 1) !== true
      ) {
        return get(value, '0'); // no fallback so could be undefined
      }
      // If Multi Select, set response only if item is selected
      return !isEmpty(value) ? value : undefined;
    },
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7006
    [TYPE_TAXONOMY_FIELD]: (value, key, component) => {
      // If Single Select
      if (!component.optionsRules?.multiSelect) {
        const firstItem = get(value, '0');
        return !firstItem ? undefined : JSON.stringify(firstItem);
      }
      // If Multi Select, set response only if item is selected
      // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7006
      return isEmpty(value) ? undefined : value.map(val => JSON.stringify(val));
    },
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7006
    [TYPE_DATE_FIELD]: value => value,
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7006
    [TYPE_TEXT_FIELD]: (value, key, component) => {
      // If number field
      if (component.textType === TEXTTYPE_NUMBER) {
        const float = parseFloat(value);
        // Set response only if it is a valid number
        return !isNaN(float) ? float : undefined;
      }
      return value;
    },
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7006
    [TYPE_NUMBER_FIELD]: value => {
      const float = parseFloat(value);
      // Set response only if it is a valid number
      return !isNaN(float) ? float : undefined;
    },
  } as const;

  forEach(response, (value, key) => {
    const component = components[key];
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7053
    const responseValue = responseMap[component.type]
      ? // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7053
        responseMap[component.type](value, key, component)
      : value;
    // Set response only if it is defined
    if (
      responseValue !== undefined &&
      responseValue !== null &&
      component.visible !== false
    ) {
      newResponse[key] = responseValue;
    }
  });
  return newResponse;
};

export default updateFormResponse;
